import {
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';

export default function RefundExpired(): JSX.Element {
  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent title="Refund expired" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="⏰"
              title="Refund expired"
              description="The 30 days claim period for this refund has passed, so it can no longer be processed. Please contact the business directly if you need more information."
            />
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
}
